export const PendenciasWizard = {
  nomePaciente: 'Nome do paciente',
  convenio: 'Convênio',
  carater: 'Caráter de atendimento',
  dataSugerida: 'Data sugerida',
  centroCirurgico: 'Centro cirúrgico',
  indicacaoClinica: 'Indicação Cirúrgica',
  prioridade: 'Prioridade',
  cidPrincipal: 'CID Principal',
  tipoAnestesia: 'Tipo de anestesia',
  procedimentoPrincipal: 'Procedimento principal',
  duracaoEstimada: 'Duração estimada',
  tipoAcomodacao: 'Tipo de acomodação',
  diariasPrevistas: 'Diárias previstas',
};

export function setPendencia(step, pendencia) {
  let pendenciasPaciente = JSON.parse(localStorage.getItem('pendenciasPaciente'));
  let pendenciasSolicitacao = JSON.parse(localStorage.getItem('pendenciasSolicitacao'));
  //let pendenciasCirurgia = JSON.parse(localStorage.getItem('pendenciasCirurgia'));
  let pendenciasDatas = JSON.parse(localStorage.getItem('pendenciasDatas'));
  if (step === 0) {
    pendenciasPaciente = pendenciasPaciente.filter(e => e !== pendencia);
    localStorage.setItem('pendenciasPaciente', JSON.stringify(pendenciasPaciente));
  }
  if (step === 1) {
    pendenciasSolicitacao = pendenciasSolicitacao.filter(e => e !== pendencia);
    localStorage.setItem('pendenciasSolicitacao', JSON.stringify(pendenciasSolicitacao));
  }
  /* if (step === 2) {
    pendenciasCirurgia = pendenciasCirurgia.filter(e => e !== pendencia);
    localStorage.setItem('pendenciasCirurgia', JSON.stringify(pendenciasCirurgia));
  } */
  if (step === 2) {
    pendenciasDatas = pendenciasDatas.filter(e => e !== pendencia);
    localStorage.setItem('pendenciasDatas', JSON.stringify(pendenciasDatas));
  }
}
